import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import RubriqTranslationStatus from './RubriqTranslationStatus';
var RubriqTranslationsHeader = function RubriqTranslationsHeader(_ref) {
  var onTranslateDocument = _ref.onTranslateDocument;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center justify-content-md-end gap-md-4 py-2"
  }, /*#__PURE__*/React.createElement(RubriqTranslationStatus, null), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('translate document'),
    type: "button",
    className: "not-global btn btn-primary rounded-3",
    onClick: function onClick() {
      return onTranslateDocument();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "translate document"
  })));
};
export default RubriqTranslationsHeader;